import ButtonWithIcon from "@/src-refactor/modules/shared/components/buttons/button-with-icon/ButtonWithIcon";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import styled from "@emotion/styled";
import ReferIcon from "@icons-rf/property-panel/transfer.svg?react";
import PercentIcon from "@icons-rf/property-panel/percent-circle.svg?react";
import ReportIcon from "@icons-rf/property-panel/exclamation-circle.svg?react";
import PencilIcon from "@icons-rf/property-panel/pencil-ui.svg?react";
import LogIcon from "@icons-rf/property-panel/clock-rewind.svg?react";
import ReactivateIcon from "@icons-rf/property-panel/circular-arrows.svg?react";
import BtnSimple from "@/src-refactor/modules/shared/components/buttons/BtbSimple";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import DeletePropertyModal from "../modals/delete-modal/DeleteModal";
import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
import ReportProperty from "../modals/report-property/ReportProperty";
import { C_PROPERTIES_STATUS } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import { useLoggedUser } from "@/shared/store/auth";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import { useNavigate, useParams } from "react-router-dom";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import React, { useMemo, useState } from "react";
import {
  RefererContext,
  RefererPropertiesContext
} from "@/src-refactor/modules/shared/context/referer-property/RefererProperties.context";
import WarnIcon from "@icons-rf/property-panel/warning-triangule.svg?react";
import RemaxIcon from "@icons-rf/remax-logo.svg?react";
import PDFPropertyMain from "../pdf-property/PDFPropertyMain";
import useDropProperty from "@/src-refactor/modules/private/properties/hooks/useDropProperty/useDropProperty";
import useActivateProperty from "@rf/property/module/hooks/useActivateProperty/useActivateProperty";
import usePropertyShareReferPropertyModal from "@rf/property/module/context/useReferProperty";

import usePropertyImagesDownload from "@rf/property/module/hooks/usePropertyImagesDownload/usePropertyImagesDownload";
import { IconFileDownload, IconFileTypePdf } from "@tabler/icons-react";
import MxLoading from "@rf-l1/loading/MxLoading";
import { Box } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import useActivationRequest from "@/src-refactor/modules/private/properties/pages/detail/hook/useActivationRequest";
const PropertyPanel = () => {
  const { handleDropProperty } = useDropProperty();
  const { handleActivateProperty } = useActivateProperty();
  const { handleOpenReferProperty } = usePropertyShareReferPropertyModal();
  const { handleSentActivationRequest } = useActivationRequest();

  const refContext = React.useRef<RefererContext | null>(null);

  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const {
    PROPERTY_DETAIL: { principalData, agents, card, cardProperty }
  } = useRealEstateDetailContext();

  const {
    userLogged: { userData }
  } = useLoggedUser();
  const { userIs } = useUserHasPermission();

  const onClickOpenModal = (id: string) => {
    const button = document.getElementById(id);
    if (button) {
      button.click();
    }
  };

  const goTo = () => {
    if (principalData.is_project) {
      if (principalData.realstatetype_id == 14) {
        navigate(C_PATH_ROUTES.REALESTATE.PROJECT_UPDATE(principalData.id));
      } else {
        navigate(C_PATH_ROUTES.REALESTATE.PROJECT_UPDATE(principalData.parent_id));
      }
    } else {
      navigate(C_PATH_ROUTES.REALESTATE.UPDATE(principalData.id));
    }
  };

  const redirectReportCommission = () => {
    window.location.href =
      ENVIRONMENT_VAR.MAXCORE_DOMAIN_V1 +
      `/commissions/create?id=${principalData.id}`;
  };

  const onScrollDataLog = () => {
    const container = document.getElementById("data-log-container");
    if (container) {
      container.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onRedirectToRemax = () => {
    const url = `${ENVIRONMENT_VAR.REMAX_DOMAIN}${
      principalData.is_collection ? "/collection" : ""
    }/propiedad/${principalData?.realstate_type
      .replaceAll(" ", "-")
      .replaceAll("/", "o")
      .toLowerCase()}/${principalData.id}`;
    window.open(url, "_blank");
  };

  const userLoggedIsCreator = useMemo(
    () => agents.some(item => item.id === userData?.people_id),
    [agents]
  );
  const agencieIds = agents.map(agent => agent.agency_id);
  const agentIds = agents.map(agent => agent.id);
  const isAdmin = userIs(ERolesCode.ADMIN);
  const isSuperAdmin = userIs(ERolesCode.SUPER_ADMIN);
  const isPendingProperty =
    principalData.property_status.id == C_PROPERTIES_STATUS.PENDING.id;
  const isActiveProperty =
    principalData.property_status.id == C_PROPERTIES_STATUS.ACTIVE.id;
  const isNegotiationProperty =
    principalData.property_status.id == C_PROPERTIES_STATUS.INNEGOTIATION.id;
  const propertyInConflict =
    principalData.property_status.id === C_PROPERTIES_STATUS.INCONFLICT.id;
  const adminBelongsToAgencyOfAnyAgent =
    isAdmin && agencieIds.includes(userData?.agency.id!);
  const agentsCaptadores = agentIds.includes(userData?.people_id!);
  const propertyDropped =
    principalData.property_status.id === C_PROPERTIES_STATUS.DROPPED.id;
  const propertyIsProject = principalData.is_project;

  const permitios = {
    canRefer: isActiveProperty,
    canReportCommission:
      (isActiveProperty || isNegotiationProperty) && !propertyIsProject,
    canReportProperty: true,
    canEditProperty:
      isSuperAdmin || adminBelongsToAgencyOfAnyAgent || agentsCaptadores,
    canLogData: true,
    canExtendTimeAndActivate:
      isSuperAdmin && (propertyDropped || isNegotiationProperty),
    canExtendTime: isSuperAdmin && isActiveProperty,
    canActivate: isSuperAdmin && isPendingProperty,
    canDelete: isSuperAdmin,
    canRequestReactivation:
      (propertyDropped || isNegotiationProperty) && agentsCaptadores,
    canDrop:
      (isSuperAdmin && !propertyDropped) ||
      (userLoggedIsCreator &&
        (isActiveProperty ||
          isNegotiationProperty ||
          isPendingProperty ||
          propertyInConflict)),
    inConflict: propertyInConflict && isSuperAdmin,
    openWebsite: isActiveProperty
  };

  const toggleModalReferer = () => {
    const button = document.getElementById(`btn-referer-properties`);
    if (refContext.current) {
      refContext.current.addProperty(card[0]);
      refContext.current.setFloatMode(false);
    }
    if (button) {
      button.click();
    }
  };

  // const handleActivateProperty = () => {
  //   onActivatePropertyModal({
  //     id: principalData.id,
  //     isDrop: propertyDropped
  //   });
  // };

  return (
    <Container>
      <TextSimple color="blue" size="sub-title" weight="bold" font="gotham">
        PANEL DE LA PROPIEDAD
      </TextSimple>
      <ContainerButtons>
        {permitios.canRefer && (
          <RefererPropertiesContext
            ref={refContext}
            children={
              <ButtonWithIcon
                title="Referir"
                icon={<ReferIcon />}
                onClick={() => handleOpenReferProperty([cardProperty])}
              />
            }
          />
        )}

        {permitios.canReportCommission && (
          <ButtonWithIcon
            title="Reportar comisión"
            icon={<PercentIcon />}
            onClick={redirectReportCommission}
          />
        )}
        {permitios.canReportProperty && (
          <ButtonWithIcon
            title="Reportar propiedad"
            icon={<ReportIcon />}
            onClick={() => onClickOpenModal(`value-${principalData.id}-report`)}
          />
        )}
        {permitios.canEditProperty && (
          <ButtonWithIcon
            title="Editar propiedad"
            icon={<PencilIcon />}
            onClick={() => goTo()}
          />
        )}

        {permitios.inConflict && (
          <ButtonWithIcon
            title={"Resolver conflicto"}
            icon={<WarnIcon />}
            onClick={() => {
              navigate(C_PATH_ROUTES.REALESTATE.RESOLVE_CONFLICT(+id!));
            }}
          />
        )}

        {permitios.canExtendTimeAndActivate && (
          <ButtonWithIcon
            title={"Activar y extender disponibilidad"}
            icon={<ReactivateIcon />}
            onClick={() =>
              handleActivateProperty({
                propertyId: principalData.id.toString(),
                title: "Activar y extender disponibilidad",
                labelSubmitButton: "Activar y extender",
                isProject: Boolean(principalData.is_project),
                hasRestorableUnits: principalData.hasRestorableUnits
              })
            }
          />
        )}

        {permitios.canExtendTime && (
          <ButtonWithIcon
            title={"Extender disponibilidad"}
            icon={<ReactivateIcon />}
            onClick={() =>
              handleActivateProperty({
                propertyId: principalData.id.toString(),
                title: "Extender disponibilidad",
                labelSubmitButton: "Extender"
              })
            }
          />
        )}
        {permitios.canActivate && (
          <ButtonWithIcon
            title={"Aprobar"}
            icon={<ReactivateIcon />}
            onClick={() =>
              handleActivateProperty({
                propertyId: principalData.id.toString(),
                title: "Aprobar",
                labelSubmitButton: "Aprobar"
              })
            }
          />
        )}

        <PDFPropertyMain />

        {/* <MXDownloadPropertyButton /> */}

        {/* {permitios.canLogData && (
          <ButtonWithIcon
            title="Log de datos"
            icon={<LogIcon />}
            onClick={onScrollDataLog}
          />
        )} */}

        {/* {permitios.canDelete && (
          <Custom>
            <ButtonWithIcon
              onClick={() => onClickOpenModal(`${principalData.id}`)}
              title="Eliminar"
              icon={<TrashIcon />}
            />
          </Custom>
        )} */}
        <div style={{ display: "flex", gap: "10px" }}>
          <DownLoadImagesButton />
        </div>
      </ContainerButtons>

      <BottomButtons>
        {permitios.canDrop && (
          <BtnSimple
            noWrap={true}
            onClick={() =>
              handleDropProperty({
                propertyId: principalData.id.toString(),
                variant: Boolean(principalData.is_project) ? "project" : "property"
              })
            }
            variant-custom="red"
          >
            DAR DE BAJA
          </BtnSimple>
        )}

        {permitios.openWebsite && (
          <BtnSimple
            noWrap={true}
            startIcon={<RemaxIcon />}
            onClick={onRedirectToRemax}
          >
            Ver en RE/MAX RD
          </BtnSimple>
        )}

        {permitios.canRequestReactivation && (
          <BtnSimple
            noWrap={true}
            onClick={() => {
              console.log("áaaaa");
              handleSentActivationRequest({ realEstateId: principalData.id });
            }}
          >
            Solicitar reactivación
          </BtnSimple>
        )}
      </BottomButtons>

      {/* <UnsubscribePropertyModal
        id={`value-${principalData.id}`}
        propertyId={principalData.id}
        isDetail
        isProject={principalData.is_project}
      /> */}
      {/* <DeletePropertyModal id={`${principalData.id}`} /> */}
      <ReportProperty custom_id={`value-${principalData.id}-report`} />
    </Container>
  );
};

export default PropertyPanel;

const Container = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 10px 20px 15px 35px;
  svg {
    width: 15px;
    height: 15px;
  }
  background: #fff;
`;
const ContainerButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  svg {
    color: var(--m-color-blue-03);
  }
`;

const BottomButtons = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  padding-right: 10px;
`;

const Custom = styled.div`
  * {
    color: red;
  }

  svg {
    color: red;
    fill: red;
  }
`;

const DownLoadImagesButton = () => {
  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();

  const [isLoading, setIsLoading] = useState(false);

  const { downloadImages } = usePropertyImagesDownload();

  const handleDownloadImages = async () => {
    setIsLoading(true);
    await downloadImages(principalData.pictures, principalData.id);
    setIsLoading(false);
  };

  return (
    <Box sx={{}}>
      <MxButton2
        variant="outlined"
        color="inherit"
        startIcon={<IconFileDownload />}
        onClick={handleDownloadImages}
        disabled={isLoading}
        sx={{
          padding: "0px 7px",
          fontWeight: 400,
          "&.Mui-disabled": {
            backgroundColor: "transparent",
            borderColor: "transparent"
          }
        }}
      >
        {isLoading ? "Descargando..." : "Descargar imágenes"}
      </MxButton2>
      {/* <ButtonWithIcon
        title={}
        icon={isLoading ? <MxLoading /> : <IconFileDownload />}
        onClick={handleDownloadImages}
      /> */}
    </Box>
  );
};
